<template>
  <div class="mx-4">
    <AddSupplierDialog />
    <v-divider></v-divider>
    <v-data-table :headers="headers" :items="suppliers"  class="elevation-0" @click:row="goToSupplierProductsPage">
      <template v-slot:[`item.isAccountVerified`]="{item}">
        <v-icon v-if="item.isAccountVerified" color="farmer_green">verified_user</v-icon>
        <v-icon v-else color="warning">error</v-icon>
      </template>
      <template v-slot:[`item.creationError`]="{item}">
        <v-alert v-if="item.creationError.length > 0" type="error" dense text>{{item.creationError}}</v-alert>
      </template>

      <template v-if="hover" v-slot:[`item.actions`]="{ item }">
        <v-row>
          <UpdateSupplierDialog :supplier="item"/>
          <DeleteSupplierDialog :supplier="item" @supplier-deleted="removeSupplier($event)"/>
        </v-row>
      </template>
    </v-data-table>
    <v-divider></v-divider>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  components: {
    AddSupplierDialog: () => import('@/components/admin/supplier/AddSupplierDialog'),
    UpdateSupplierDialog: () => import('@/components/admin/supplier/UpdateSupplierDialog'),
    DeleteSupplierDialog: () => import('@/components/admin/supplier/DeleteSupplierDialog')
  },
  name: 'suppliers',
  data() {
    return {
      totalItems: 0,
      items: [],
      // loading: true,
      options: {},
      hover: true,
      headers: [
        { text: 'First Name', value: 'firstName' },
        { text: 'Last Name', value: 'lastName' },
        { text: 'E-mail', value: 'email' },
        { text: 'Phone Number', value: 'phoneNumber' },
        {
          text: 'Type',
          value: 'type'
        },
        {
          text: 'Verification Status',
          align: 'center',
          value: 'isAccountVerified'
        },
        {
          text: 'Errors',
          align: 'left',
          value: 'creationError'
        },
        { text: 'Actions', value: 'actions', sortable: false }
      ]
    }
  },
  watch: {
    suppliers() {
      if (this.suppliers) {
        this.loading = false
      }
    }
  },
  mounted() {
  },
  computed: {
    ...mapGetters(['suppliers', 'totalSuppliers'])
  },
  methods: {
    updateSupplier(supplier) {
      this.$router.push({
        name: 'UpdateSupplier',
        params: { supplier, id: supplier.id }
      })
    },
    removeSupplier(supplier) {
      const index = this.suppliers.indexOf(supplier)
      this.suppliers.splice(index, 1)
    },
    goToSupplierProductsPage(supplier) {
      // go to the route /suppliers/supplier.id
      this.$router.push({
        name: 'SupplierProducts',
        params: { id: supplier.id }
      })
    }
  }
}
</script>

<style scoped>
  .v-data-table:hover {
    cursor: pointer;
  }
</style>
